import { render } from "./RegfForm.vue?vue&type=template&id=fa4b428e"
import script from "./RegfForm.vue?vue&type=script&lang=js"
export * from "./RegfForm.vue?vue&type=script&lang=js"

import "./RegfForm.vue?vue&type=style&index=0&id=fa4b428e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__